import React from 'react'
import { Modal, Button, Row, Col } from 'react-bootstrap'
import { S3_URL } from '../../../constants';

export default function OrderDetailModal({ datas, open, handleClose }) {

   // Format date
   const formatDate = (dateString) => {
      const date = new Date(dateString);
      return date.toLocaleString('lo-LA', {
         year: 'numeric',
         month: '2-digit',
         day: '2-digit',
         hour: '2-digit',
         minute: '2-digit'
      });
   }

   // Get status in Lao
   const getStatusText = (status) => {
      switch (status) {
         case 'PAYMENT_PROCESSING':
            return 'ກຳລັງດຳເນີນການຊຳລະເງິນ';
         case 'WAITING':
            return 'ລໍຖ້າ';
         default:
            return status;
      }
   }

   // Get payment type in Lao
   const getPaymentTypeText = (type) => {
      switch (type) {
         case 'DESTINATION':
            return 'ຊຳລະປາຍທາງ';
         default:
            return type;
      }
   }

   // console.log("logs datas location: ", datas)

   return (
      <>
         <Modal show={open} onHide={handleClose} centered size="lg">
            <Modal.Header closeButton>
               <Modal.Title>ລາຍລະອຽດອໍເດີ້: {datas?.code}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <div className="order-details">
                  {/* Shop Info */}
                  <Row>
                     <Col>
                        <div className="shop-info mb-4">
                           <h5>ຂໍ້ມູນຮ້ານຄ້າ</h5>
                           <div className="d-flex align-items-center">
                              {datas?.shop?.image && (
                                 <img
                                    src={S3_URL + datas?.shop?.image}
                                    alt={datas?.shop?.name}
                                    className="shop-image me-3"
                                    style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '50%' }}
                                 />
                              )}
                              <div>
                                 <p className="mb-0"><strong>{datas?.shop?.name}</strong></p>
                                 <p className="mb-0">ເບີໂທ: {datas?.shop?.phone}</p>
                              </div>
                           </div>
                        </div>
                     </Col>
                     <Col>
                        <div className="shop-info mb-4">
                           <h5>ຂໍ້ມູນອາຟຣິລີເອດ</h5>
                           <div>
                              <p className="mb-0">ຊື່: <strong>{datas?.infulancer?.first_name} {datas?.infulancer?.last_name}</strong></p>
                              <p className="mb-0">ເບີໂທ: {datas?.infulancer?.phone}</p>
                           </div>
                        </div>
                     </Col>
                  </Row>

                  {/* Order Info */}
                  <div className="order-info mb-4">
                     <h5>ຂໍ້ມູນການສັ່ງຊື້</h5>
                     <div className="row">
                        <div className="col-md-6">
                           <p><strong>ລະຫັດອໍເດີ້:</strong> {datas?.code}</p>
                           <p><strong>ວັນທີສັ່ງຊື້:</strong> {formatDate(datas?.createdAt)}</p>
                           <p><strong>ສະຖານະ:</strong> <span className="badge bg-warning text-dark">{getStatusText(datas?.status)}</span></p>
                           <p style={{ fontWeight: "bold" }}><strong>ລູກຄ້າ:</strong> {datas?.customerName ?? "-"}{" / "}{datas?.phone ?? "-"} </p>
                           <p><strong>ທີ່ຢູ່:</strong>  {datas?.destinationLogistic ?? "-"} </p>
                        </div>
                        <div className="col-md-6">
                           <p><strong>ປະເພດການຊຳລະ:</strong> {getPaymentTypeText(datas?.paymentType)}</p>
                           <p><strong>ສະຖານະການຊຳລະ:</strong> <span className={`badge ${datas?.isPaymented ? 'bg-success' : 'bg-danger'} text-dark}`}>{datas?.isPaymented ? 'ຊຳລະແລ້ວ' : 'ຍັງບໍ່ຊຳລະ'}</span></p>
                           <p><strong>ສະຖານະໃບເກັບເງິນ:</strong> <span className="badge bg-warning text-dark">{getStatusText(datas?.invoiceStatus)}</span></p>
                        </div>
                     </div>
                  </div>

                  {/* Products Table */}
                  <div className="products-table mb-4">
                     <h5>ລາຍການສິນຄ້າ</h5>
                     <table className="table">
                        <thead className="table-light">
                           <tr>
                              <th>ສິນຄ້າ</th>
                              <th className="text-center">ລາຄາ</th>
                              <th className="text-center">ຈຳນວນ</th>
                              <th className="text-end">ລາຄາລວມ</th>
                           </tr>
                        </thead>
                        <tbody>
                           {datas?.orders?.map((item, index) => (
                              <tr key={index}>
                                 <td>{item.productName}</td>
                                 <td className="text-center">{item.price.toLocaleString()} {item.currency}</td>
                                 <td className="text-center">{item.amount}</td>
                                 <td className="text-end">{item.totalPrice.toLocaleString()} {item.currency}</td>
                              </tr>
                           ))}
                        </tbody>
                        <tfoot className="table-light">
                           <tr>
                              <td colSpan="3" className="text-end"><strong>ຍອດອໍເດີ້:</strong></td>
                              <td className="text-end"><strong>{datas?.totalPrice?.toLocaleString()} {datas?.orders?.[0]?.currency}</strong></td>
                           </tr>
                           <tr>
                              <td colSpan="3" className="text-end"><span style={{ fontSize: 18, fontWeight: "bold", color: "#179b3f" }}>ຄ່າຄອມມິດຊັ່ນ:</span></td>
                              <td className="text-end"><span style={{ fontSize: 18, fontWeight: "bold", color: "#179b3f" }}>{datas?.totalAffiliate?.toLocaleString() ?? 0} ກີບ</span></td>
                           </tr>
                        </tfoot>
                     </table>
                  </div>

                  {/* Payment Info */}
                  {datas?.paymentType === "DESTINATION" && (
                     <div className="payment-info mb-4">
                        <div className="alert alert-info">
                           <i className="bi bi-info-circle me-2"></i>
                           ການຊຳລະເງິນຈະດຳເນີນການເມື່ອສິນຄ້າຮອດປາຍທາງ
                        </div>
                     </div>
                  )}

                  {/* Additional Notes */}
                  {datas?.cfMessage && (
                     <div className="additional-notes mb-4">
                        <h5>ໝາຍເຫດເພີ່ມເຕີມ</h5>
                        <p>{datas.cfMessage}</p>
                     </div>
                  )}
               </div>
            </Modal.Body>
            <Modal.Footer>
               <Button variant="secondary" onClick={handleClose}>
                  ປິດ
               </Button>
               {/* <Button variant="primary" onClick={handleClose}>
                  ພິມໃບບິນ
               </Button> */}
            </Modal.Footer>
         </Modal>
      </>
   )
}